module.exports = __webpack_public_path__ + "static/media/linkedin.1508df05.svg";